import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { Box, IconButton } from '@mui/material';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { fileTypeToIconMap } from '../features/file-manager';
export function renderFileTypeColumn(t, row, defaultPermissions, clearActiveRow, navigate, searchParams) {
    const activeTabId = searchParams.get('tab');
    const directoryDisabled = (row) => {
        if (row.columns.directory) {
            return !row.permissions.includes('read');
        }
        return false;
    };
    let isShared;
    if (row.columns.permissions) {
        const permissions = JSON.parse(row.columns.permissions);
        isShared = !isEqual(permissions, defaultPermissions);
    }
    const isDirectory = row.columns.directory;
    const isImage = row.columns.type.startsWith('image/');
    const hasReadPermission = row.permissions.includes('read');
    if (isDirectory) {
        const { icon: Icon, color } = fileTypeToIconMap[isShared ? 'sharedFolder' : 'folder'];
        return (React.createElement(Box, { my: -2 },
            React.createElement(IconButton, { color: 'primary', onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (row.columns.directory) {
                        if (row.permissions.includes('read')) {
                            clearActiveRow();
                            const urlParams = new URLSearchParams();
                            if (activeTabId) {
                                urlParams.set('tab', activeTabId);
                            }
                            navigate({
                                pathname: row.id,
                                search: urlParams.toString(),
                            });
                        }
                        else {
                            showErrorDialog({
                                title: t('messages.noPermission'),
                                onClose: () => undefined,
                            });
                        }
                    }
                }, disabled: directoryDisabled(row), "aria-label": isShared
                    ? t('documentPanel.sharedFolder', { name: row.columns.name })
                    : t('documentPanel.folder', { name: row.columns.name }), size: 'large' }, directoryDisabled(row) ? React.createElement(Icon, { sx: { color: 'disabled' } }) : React.createElement(Icon, { sx: { color } }))));
    }
    const image = fileTypeToIconMap[isShared ? 'sharedImage' : 'image'];
    const file = fileTypeToIconMap[isShared ? 'sharedFile' : 'file'];
    const Icon = isImage ? image.icon : file.icon;
    const color = isImage ? image.color : file.color;
    return (React.createElement(Box, { my: -2, sx: { display: 'flex', padding: 2, color: (theme) => theme.palette.text.secondary } }, hasReadPermission ? React.createElement(Icon, { sx: { color } }) : React.createElement(Icon, { sx: { color: 'disabled' } })));
}
